/**
 * Generated by orval v8.9.0 🍺
 * Do not edit manually.
 * Auth API
 * API для аутентификации и авторизации
 * OpenAPI spec version: 1.0
 */
import { useQuery } from '@tanstack/react-query';
import {
    type DataTag,
    type DefinedInitialDataOptions,
    type DefinedUseQueryResult,
    type QueryClient,
    type QueryFunction,
    type QueryKey,
    type UndefinedInitialDataOptions,
    type UseQueryOptions,
    type UseQueryResult,
} from '@tanstack/react-query';
import { authKyMutator } from '../../shared/api/kyMutator';
import { type ErrorType } from '../../shared/api/kyMutator';
import {
    type GetAuthMeParams,
    type InternalApiHttpAuthEnrollTelegramRequest,
    type InternalApiHttpAuthEnrollTelegramResponse,
    type InternalApiHttpAuthErrorResponse,
    type InternalApiHttpAuthGetMeResponse,
    type InternalApiHttpAuthLoginRequest,
    type InternalApiHttpAuthLoginResponse,
    type InternalApiHttpAuthPasswordResetRequest,
    type InternalApiHttpAuthPasswordSetRequest,
    type InternalApiHttpAuthRefreshResponse,
    type InternalApiHttpAuthSignupRequest,
    type PostAuthLoginParams,
    type PostAuthSignupParams,
} from './model';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * Выполняет вход через telegram, возвращает access и refresh токены
 * @summary Вход через telegram
 */
export const getPostAuthEnrollTelegramUrl = () => {
    return '/auth/enroll/telegram';
};

export const postAuthEnrollTelegram = async (
    internalApiHttpAuthEnrollTelegramRequest: InternalApiHttpAuthEnrollTelegramRequest,
    options?: RequestInit,
): Promise<InternalApiHttpAuthEnrollTelegramResponse> => {
    return authKyMutator<InternalApiHttpAuthEnrollTelegramResponse>(getPostAuthEnrollTelegramUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(internalApiHttpAuthEnrollTelegramRequest),
    });
};

/**
 * Выполняет вход по email и паролю, возвращает access и refresh токены
 * @summary Авторизация пользователя
 */
export const getPostAuthLoginUrl = (params?: PostAuthLoginParams) => {
    const normalizedParams = new URLSearchParams();

    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : value.toString());
        }
    });

    const stringifiedParams = normalizedParams.toString();

    return stringifiedParams.length > 0 ? `/auth/login?${stringifiedParams}` : '/auth/login';
};

export const postAuthLogin = async (
    internalApiHttpAuthLoginRequest: InternalApiHttpAuthLoginRequest,
    params?: PostAuthLoginParams,
    options?: RequestInit,
): Promise<InternalApiHttpAuthLoginResponse> => {
    return authKyMutator<InternalApiHttpAuthLoginResponse>(getPostAuthLoginUrl(params), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(internalApiHttpAuthLoginRequest),
    });
};

/**
 * Удаляет refresh токен (cookie), инвалидирует сессию и завершает авторизацию
 * @summary Выход пользователя
 */
export const getPostAuthLogoutUrl = () => {
    return '/auth/logout';
};

export const postAuthLogout = async (options?: RequestInit): Promise<void> => {
    return authKyMutator<void>(getPostAuthLogoutUrl(), {
        ...options,
        method: 'POST',
    });
};

/**
 * Проверяет валидность access токена и возвращает данные пользователя (ID и роли)
 * @summary Проверка валидности access токена и получения базовых данных пользователя
 */
export const getGetAuthMeUrl = (params?: GetAuthMeParams) => {
    const normalizedParams = new URLSearchParams();

    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : value.toString());
        }
    });

    const stringifiedParams = normalizedParams.toString();

    return stringifiedParams.length > 0 ? `/auth/me?${stringifiedParams}` : '/auth/me';
};

export const getAuthMe = async (
    params?: GetAuthMeParams,
    options?: RequestInit,
): Promise<InternalApiHttpAuthGetMeResponse> => {
    return authKyMutator<InternalApiHttpAuthGetMeResponse>(getGetAuthMeUrl(params), {
        ...options,
        method: 'GET',
    });
};

export const getGetAuthMeQueryKey = (params?: GetAuthMeParams) => {
    return ['/auth/me', ...(params ? [params] : [])] as const;
};

export const getGetAuthMeQueryOptions = <
    TData = Awaited<ReturnType<typeof getAuthMe>>,
    TError = ErrorType<InternalApiHttpAuthErrorResponse>,
>(
    params?: GetAuthMeParams,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAuthMe>>, TError, TData>>;
        request?: SecondParameter<typeof authKyMutator>;
    },
) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetAuthMeQueryKey(params);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAuthMe>>> = ({ signal }) =>
        getAuthMe(params, { signal, ...requestOptions });

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof getAuthMe>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetAuthMeQueryResult = NonNullable<Awaited<ReturnType<typeof getAuthMe>>>;
export type GetAuthMeQueryError = ErrorType<InternalApiHttpAuthErrorResponse>;

export function useGetAuthMe<
    TData = Awaited<ReturnType<typeof getAuthMe>>,
    TError = ErrorType<InternalApiHttpAuthErrorResponse>,
>(
    params: undefined | GetAuthMeParams,
    options: {
        query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAuthMe>>, TError, TData>> &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getAuthMe>>,
                    TError,
                    Awaited<ReturnType<typeof getAuthMe>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof authKyMutator>;
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetAuthMe<
    TData = Awaited<ReturnType<typeof getAuthMe>>,
    TError = ErrorType<InternalApiHttpAuthErrorResponse>,
>(
    params?: GetAuthMeParams,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAuthMe>>, TError, TData>> &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getAuthMe>>,
                    TError,
                    Awaited<ReturnType<typeof getAuthMe>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof authKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetAuthMe<
    TData = Awaited<ReturnType<typeof getAuthMe>>,
    TError = ErrorType<InternalApiHttpAuthErrorResponse>,
>(
    params?: GetAuthMeParams,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAuthMe>>, TError, TData>>;
        request?: SecondParameter<typeof authKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Проверка валидности access токена и получения базовых данных пользователя
 */

export function useGetAuthMe<
    TData = Awaited<ReturnType<typeof getAuthMe>>,
    TError = ErrorType<InternalApiHttpAuthErrorResponse>,
>(
    params?: GetAuthMeParams,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAuthMe>>, TError, TData>>;
        request?: SecondParameter<typeof authKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
    const queryOptions = getGetAuthMeQueryOptions(params, options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Устанавливает новый пароль
 * @summary Установка нового пароля
 */
export const getPatchAuthPasswordUrl = () => {
    return '/auth/password';
};

export const patchAuthPassword = async (
    internalApiHttpAuthPasswordSetRequest: InternalApiHttpAuthPasswordSetRequest,
    options?: RequestInit,
): Promise<void> => {
    return authKyMutator<void>(getPatchAuthPasswordUrl(), {
        ...options,
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(internalApiHttpAuthPasswordSetRequest),
    });
};

/**
 * Отправляет код для восстановления аккаунта
 * @summary Восстановление аккаунта пользователя
 */
export const getPostAuthPasswordResetUrl = () => {
    return '/auth/password/reset';
};

export const postAuthPasswordReset = async (
    internalApiHttpAuthPasswordResetRequest: InternalApiHttpAuthPasswordResetRequest,
    options?: RequestInit,
): Promise<void> => {
    return authKyMutator<void>(getPostAuthPasswordResetUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(internalApiHttpAuthPasswordResetRequest),
    });
};

/**
 * Получает refresh токен из cookie, выдает новый access токен и обновляет refresh токен
 * @summary Обновление токенов
 */
export const getPostAuthRefreshUrl = () => {
    return '/auth/refresh';
};

export const postAuthRefresh = async (options?: RequestInit): Promise<InternalApiHttpAuthRefreshResponse> => {
    return authKyMutator<InternalApiHttpAuthRefreshResponse>(getPostAuthRefreshUrl(), {
        ...options,
        method: 'POST',
    });
};

/**
 * Создает нового пользователя. Если передан password, сразу возвращает данные пользователя; иначе отправляет письмо для установки пароля
 * @summary Регистрация пользователя
 */
export const getPostAuthSignupUrl = (params?: PostAuthSignupParams) => {
    const normalizedParams = new URLSearchParams();

    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : value.toString());
        }
    });

    const stringifiedParams = normalizedParams.toString();

    return stringifiedParams.length > 0 ? `/auth/signup?${stringifiedParams}` : '/auth/signup';
};

export const postAuthSignup = async (
    internalApiHttpAuthSignupRequest: InternalApiHttpAuthSignupRequest,
    params?: PostAuthSignupParams,
    options?: RequestInit,
): Promise<InternalApiHttpAuthGetMeResponse | void> => {
    return authKyMutator<InternalApiHttpAuthGetMeResponse | void>(getPostAuthSignupUrl(params), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(internalApiHttpAuthSignupRequest),
    });
};
